import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';

import Button from "../../components/UI/Input/Button/Button";

import logoblu from "../../assets/img/logo_colored.svg";
import logobianco from "../../assets/img/logo_white.svg";

const VerifiedEmailPage = () => {
  const location = useLocation();
  const { t } = useTranslation("noku-account");

  const [returnTo, setReturnTo] = useState("/app");
  const [isForgot, setForgot] = useState(false);

  // Get returnTo value
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const returnTo = searchParams.get("returnTo");
    setReturnTo(returnTo);
    if (returnTo?.indexOf("forgot-password") >= 0) {
      setForgot(true);
    }
  }, [location]);

  return (
    <div className="login">
      <div className="flex-container stretch">
        <div className="block flex-container">
          <div className="mask only-mobile" />
          <div className="z9">
            <div className="logo">
              <img src={logoblu} alt="" className="only-desktop" />
              <img src={logobianco} alt="" className="only-mobile" />
            </div>
            <div className="title">{t('verifiedEmailTitle')}</div>
            {
              returnTo ? (
                <Button
                  type="button"
                  href={returnTo}
                >
                  {isForgot ? t('backToForgot') : t('backToApp')}
                </Button>
              ) : (
                <>
                {/*                
                <div className={classes.subtitle}> 
                  {t('verifiedEmailDescription')}
                </div>
                */}
                </>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifiedEmailPage;
